import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { DocumentType } from 'document/model/document.type';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { DocumentI18nInput } from '../model/document-i18n.input';
import {
	documentLocalization,
	documentModule,
	documentPhase,
	documentSection,
} from '../model/document.fragments';
import { DocumentOutput } from '../model/document.output';

export interface SaveDocumentInput {
	readonly id: string;
	readonly userId: string;
	readonly phaseId: string;
	readonly moduleId: string;
	readonly type: DocumentType;
	readonly localizations: DocumentI18nInput[];
}

export interface SaveDocumentParams {
	input: SaveDocumentInput;
}

@Injectable({ providedIn: 'root' })
export class SaveDocumentApiMutation extends ApiMutation<
	DocumentOutput,
	SaveDocumentParams
> {
	client = 'content';
	document = gql`
		mutation SaveDocument($input: SaveDocumentInput!) {
			saveDocument(input: $input) {
				id
				type
				ownerId
				updateTimestamp
				phase {
					...DocumentPhase
				}
				section {
					...DocumentSection
				}
				module {
					...DocumentModule
				}
				localizations {
					...DocumentLocalization
				}
				lastOpenTimestamp
				creationTimestamp
			}
		}
		${documentPhase}
		${documentModule}
		${documentSection}
		${documentLocalization}
	`;
	method = 'saveDocument';
}
